/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_Empty_TitleInputs */

const en_newsletter_archive_empty_title = /** @type {(inputs: Newsletter_Archive_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues yet`)
};

/**
* | output |
* | --- |
* | "No issues yet" |
*
* @param {Newsletter_Archive_Empty_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_empty_title = /** @type {((inputs?: Newsletter_Archive_Empty_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_Empty_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_empty_title(inputs)
});